import { getConfig } from '@constants';

export const isMobile = function() {
	const userAgent = !IS_SSR ? navigator?.userAgent : getConfig().userAgent;

	return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};
